import { Fragment, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------
import Modal from "src/components/common/modal";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import FileSystem from "src/components/common/fileSystem";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, MyDate, weeknum, getTimeStamp, 
    getJsonArray, MyFormData, myAxios, onlyUnique, 
    scroll, usaExpireColorCode, addDate, 
    restDayProjectHashKey, boolAndReducer, getDatefromWeekNum, 
    fileSystemSchemaForProjects,
    appTitle, 
} from "src/components/common/functions";
import { WorkLogContent } from "./workLogContent";
//--------------------------------------------------------------------------------------------
// workLog: 
// workLogStatus, 
// perDiem, 
// usaTicketDate, 
// startTime, 
// endTime, 
// projectName, 
// category, 
// projectManager, 
// projectDescription, 
// workInstructionDescription, 
// supervisor, 
// teamLeadName, 
// laborCategory, 
// truckNumber, 
// location, 
// decisionNotes, 
// workInstructionFiles, 
// projectFiles, 
// workLogFiles, 
// workLogHashKey, 
// workInstructionHashKey, 
// attachmentFolderId, 
// laborFolderId, 
// potholingForm, 
// forms, 
// jobTag, 
//--------------------------------------------------------------------------------------------
const title = "WorkLogs";
export default function WorkLogs({tabTitle}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [weeks, setWeeks] = useState([]);
    const [curWeek, setCurWeek] = useState(weeknum(new Date()));
    const [workLogHistory, setWorkLogsHistory] = useState(false);
    const [showSetting, setShowSetting] = useState(false);
    const [workLogs, setWorkLogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        startTimeMin: "",
        startTimeMax: "",
        endTimeMin: "", 
        endTimeMax: "",
        projectName: "", 
        category: "", 
        subCategory: "", 
        workLogStatus: "",
        projectManager: "",
        projectDescription: "",
        workInstructionDescription: "",
        supervisor: "",
        teamLeadName: "",
        laborCategory: "",
        truckNumber: "",
        perDiem: "all",
        location: "",
        decisionNotes: "",
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    const [showLoading, setShowLoading]  = useState(false);
    //--------------------------------------------------------------------------------------------
    const id = location.pathname.split("/")[2];
    const formName = location.pathname.split("/")[3];
    const subFormName = location.pathname.split("/")[4];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredWorkLogs0 = workLogs
    .filter(workLog => 
        (workLogHistory?
            workLog.workLogStatus === "Submitted" || workLog.workLogStatus === "Approved"
            :
            (workLog.workLogStatus === "Rejected"|| workLog.workLogStatus === "Created")
        ) 
    );
    const filteredWorkLogs = filteredWorkLogs0
    .map(workLog => ({
        ...workLog,
        perDiem: workLog.perDiem === ""?"No":workLog.perDiem,
        usaTicketExpirationDate: workLog.usaTicketDate?addDate(workLog.usaTicketDate, 28):""
    }))
    .filter(workLog => 
        (curFilter.startTimeMin?workLog.startTime >= curFilter.startTimeMin:true)
        && (curFilter.startTimeMax?workLog.startTime <= curFilter.startTimeMax:true)
        && (curFilter.endTimeMin?workLog.endTime >= curFilter.endTimeMin:true)
        && (curFilter.endTimeMax?workLog.endTime <= curFilter.endTimeMax:true)
        && (curFilter.projectName?workLog.projectName?.toLowerCase().indexOf(curFilter.projectName.toLowerCase()) > -1:true)
        && (curFilter.category?workLog.category?.replace(/ {2}/g," ") === curFilter.category:true)
        && (curFilter.subCategory?workLog.subCategory?.replace(/ {2}/g," ") === curFilter.subCategory:true)
        && (curFilter.workLogStatus?workLog.workLogStatus?.replace(/ {2}/g," ") === curFilter.workLogStatus:true)
        && (curFilter.projectManager?workLog.projectManager?.replace(/ {2}/g," ") === curFilter.projectManager:true)
        && (curFilter.projectDescription?workLog.projectDescription?.toLowerCase().indexOf(curFilter.projectDescription.toLowerCase()) > -1:true)
        && (curFilter.workInstructionDescription?workLog.workInstructionDescription?.toLowerCase().indexOf(curFilter.workInstructionDescription.toLowerCase()) > -1:true)
        && (curFilter.supervisor?workLog.supervisor?.replace(/ {2}/g," ") === curFilter.supervisor:true)
        && (curFilter.teamLeadName?workLog.teamLeadName?.replace(/ {2}/g," ") === curFilter.teamLeadName:true)
        && (curFilter.laborCategory?workLog.laborCategory?.replace(/ {2}/g," ") === curFilter.laborCategory:true)
        && (curFilter.truckNumber?workLog.truckNumber === curFilter.truckNumber:true)
        && (curFilter.perDiem !== "all"?workLog.perDiem === curFilter.perDiem:true)
        && (curFilter.location?workLog.location?.toLowerCase().indexOf(curFilter.location.toLowerCase()) > -1:true)
        && (curFilter.decisionNotes?workLog.decisionNotes?.toLowerCase().indexOf(curFilter.decisionNotes.toLowerCase()) > -1:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(workLog)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentWorkLogs = filteredWorkLogs.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredWorkLogs.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const id = history.location.pathname.split("/")[2];
        const getData = async () => {
            const formData = new MyFormData();
            //---------------------------------------------------
            setShowLoading(true);
            const resWeeks = await myAxios("workLogs/readWeek.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resWeeks) return;
            //---------------------------------------------------
            const dateArray = [];
            const min = new Date(resWeeks.data.minTime.replace(/-/g, "/"));
            const max = new Date(resWeeks.data.maxTime.replace(/-/g, "/"));
            while(min < max){
                dateArray.push(weeknum(min));
                min.setDate(min.getDate() + 7);
            }
            if(!dateArray.includes(weeknum(max))){
                dateArray.push(weeknum(max));
            }
            if(!dateArray.includes(curWeek)){
                dateArray.push(curWeek);
            }
            setWeeks(dateArray);
            //-----------------------------------------------------------------------------
            let weekStart = getDatefromWeekNum(curWeek, 0);
            let weekEnd = getDatefromWeekNum(curWeek, 6);
            if(id){
                formData.append("workLogHashKey", id);
                //---------------------------------------------------
                setShowLoading(true);
                const res0 = await myAxios("workLogs/readWorkLog.php", formData);
                if(!isMounted) return;
                setShowLoading(false);
                if(!res0) return;
                //---------------------------------------------------
                if(res0.data === ""){
                    history.push(`/${title}`);
                }else{
                    const week = weeknum(res0.data.startTime);
                    setCurWeek(week);
                    weekStart = getDatefromWeekNum(week, 0);
                    weekEnd = getDatefromWeekNum(week, 6);
                }
            }
            formData.append("weekStart", weekStart);
            formData.append("weekEnd", weekEnd);
            //---------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("workLogs/readWorkLogsByWeek.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //---------------------------------------------------
            const mainData = res.data.map(workLog =>({
                ...workLog, 
                workInstructionFiles: getJsonArray(workLog.workInstructionFiles),
                projectFiles: getJsonArray(workLog.projectFiles),
                workLogFiles: getJsonArray(workLog.workLogFiles)
            }));
            setWorkLogs(mainData);
            if(!mainData.some(workLog => id === workLog.workLogHashKey)){
                //---------------------------------------------------------------------------
                // for technician access work log from google calendar work Instruction links
                const workInstruction = mainData.find(workLog => id === workLog.workInstructionHashKey);
                if(workInstruction){
                    history.replace(`${workInstruction.workLogHashKey}`);
                    return;
                }
                //---------------------------------------------------------------------------
                if(id !== undefined){
                    history.replace(`/${title}`);
                }
                return;
            }
            //-----------------------------------------------------------
            // for history work logs
            
            //-----------------------------------------------------------
        }
        getData();
        return () => {isMounted = false;}
    },[history, curWeek, updateDateTime])
    useEffect(() => {
        const thisWorkLog = workLogs.find(workLog => id === workLog.workLogHashKey);
        if(!thisWorkLog) return;
        if(thisWorkLog.workLogStatus === "Submitted" || 
        thisWorkLog.workLogStatus === "Approved"){
            setWorkLogsHistory(true);
        }
        const hashkeys = workLogs
        .filter(workLog => (thisWorkLog.workLogStatus === "Submitted" || thisWorkLog.workLogStatus === "Approved")?
        (workLog.workLogStatus === "Submitted" ||
        workLog.workLogStatus === "Approved")
        :(workLog.workLogStatus === "Rejected"||
        workLog.workLogStatus === "Created"))
        .map(workLog => workLog.workLogHashKey);
        setCurrentPage(Math.ceil((hashkeys.indexOf(id) + 1) / itemsPerPage));
        scroll(id);
    }, [workLogs, id, itemsPerPage])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Work Log
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {curWeek}
                        onChange = {e => {
                            setCurWeek(e.currentTarget.value);
                            history.push("/WorkLogs");
                        }}
                    >
                        {weeks.map((wk, key) => <option key = {key}>{wk}</option>)}
                    </select>
                </span>
                <span
                    className = "pointer"
                    onClick = {() => {
                        setWorkLogsHistory(h => !h);
                        setCurrentPage(1);
                    }}
                >
                    {workLogHistory?"Active":"History"}
                </span>
                <span
                    className = "pointer"
                    onClick = {() => setShowSetting(true)}
                >
                    Settings
                </span>
                {showSetting?
                <SettingsForm
                    closeIt = {() => setShowSetting(false)}
                />:null}
                <span
                    className = "pointer round p-1" style = {{
                        backgroundColor: Object.entries(curFilter).some(([key, value]) => defaultFilter[key] !== value)?
                        "rgb(0,123,255)"
                        :null, 
                    }}
                    onClick = {() => {setShowFilterForm(true)}}
                >
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                    filteredWorkLogs0 = {filteredWorkLogs0}
                />:null}
                <span
                    className = "pointer"
                    onClick = {() => {
                        if(!filteredWorkLogs.length){
                            window.alert("No data to export.");
                            return;
                        }
                        setShowLoader(true);
                        const workbook = new exceljs.Workbook();
                        workbook.creator = user.userName;
                        workbook.created = new Date();
                        workbook.calcProperties.fullCalcOnLoad = true;
                        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
                        worksheet.state = "visible";
                        worksheet.properties.defaultColWidth = 22.57;
                        const rows = filteredWorkLogs.map(post => [
                            post.startTime,
                            post.endTime, 
                            post.laborCategory, 
                            post.truckNumber, 
                            post.perDiem, 
                            post.projectName,
                            post.workLogStatus,
                            post.projectManager,
                            post.projectDescription,
                            post.workInstructionDescription,
                            post.supervisor,
                            post.teamLeadName,
                            post.location,
                            post.decisionNotes
                        ])
                        worksheet.addTable({
                            name: "MyTable",
                            ref: "A1",
                            totalsRow: true,
                            style: {
                                showRowStripes: true,
                            },
                            columns: [
                                { name: "Start Time", filterButton: true},
                                { name: "End Time", filterButton: true},
                                { name: "Labor Category", filterButton: true},
                                { name: "Truck Number", filterButton: true},
                                { name: "Per Diem", filterButton: true},
                                { name: "Project Name", filterButton: true},
                                { name: "Work Log Status", filterButton: true},
                                { name: "Project Manager", filterButton: true},
                                { name: "Project Description", filterButton: true},
                                { name: "WorkInstruction Description", filterButton: true},
                                { name: "Supervisor", filterButton: true},
                                { name: "Team Lead Name", filterButton: true},
                                { name: "Location", filterButton: true},
                                { name: "Approver Comments", filterButton: true}
                            ],
                            rows: rows,
                        });
                        worksheet.columns.forEach(column => {
                            const minLength = 18;
                            let maxLength = 0;
                            column["eachCell"]({ includeEmpty: true }, cell => {
                                // exclude row 1 ----------
                                if(cell.row === 1) return;
                                //-------------------------
                                const columnLength = cell.value?
                                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                                :minLength;
                                if(columnLength > maxLength){
                                    maxLength = columnLength;
                                }
                            });
                            column.width = maxLength < minLength ? minLength : maxLength;
                        });
                        worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
                        workbook.xlsx.writeBuffer().then(buffer => {
                            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `work logs export ${(new MyDate()).s()}.xlsx`);
                            setShowLoader(false);
                        })
                    }}
                >
                    Export
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentWorkLogs.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                <th>Planned Time Range</th>
                                <th>Project Name</th>
                                <th>Category</th>
                                <th>Sub Category</th>
                                <th>Work Log Status</th>
                            </tr>
                            </thead>
                            <tbody>
                                {currentWorkLogs.map((workLog, workLogIndex) => 
                                    <RenderedRow
                                        key = {workLogIndex}
                                        id = {id}
                                        history = {history}
                                        setWorkLogs = {setWorkLogs}
                                        workLogs = {workLogs}
                                        formName = {formName}
                                        subFormName = {subFormName}
                                        
                                        workLog = {workLog}
                                        {...workLog}
                                    />
                                )}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredWorkLogs.length?
                <Footer
                    length = {filteredWorkLogs.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}

function SettingsForm({ closeIt }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        //---------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workLogs/updateWorkLogsSetting.php", formData);
        if(!res) return;
        setShowLoader(false);
        //---------------------------------------------------------
        user.workLogNotification = formData.get("workLogNotification");
        closeIt();
    }
    
    return (
        <Modal
            closeIt = {closeIt}
            actionKey = {"Save"}
            handleFormSubmit = {handleSubmit}
            title = "Settings"
            width = {600}
            maxWidth = {"100%"}
        >
            <div className = "my-2" style = {{display: "flex"}}>
                <label className = "mr-3 font-weight-bold">Notification:</label>
                <select
                    className = "form-control"
                    name = "workLogNotification"
                    defaultValue = {user.workLogNotification}
                >
                    <option value = "">No</option>
                    <option>Yes</option>
                </select>
                
            </div>
            <div className = "mb-2">
                <label>(send at midnight every day for non-submitted work log)</label>
            </div>
        </Modal>
    )
}

function FilterForm({
    closeIt, setCurrentPage,
    curFilter, setFilter,
    defaultFilter, filteredWorkLogs0
}){
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {600}
            maxWidth = {"100%"}
        >
            <div className = "mt-3 mb-3">
                <span
                    className = "btn btn-secondary"
                    onClick = {() => {
                        setFilter(defaultFilter);
                        setCurrentPage(1);
                    }}
                >
                    Clear Filter
                </span>
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Start Time:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.startTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.startTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, startTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.startTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "mr-3 form-control"
                    value = {curFilter.startTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, startTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.startTimeMax || curFilter.startTimeMin?
                <span
                    onClick = {() => {setFilter({...curFilter, startTimeMin: "", startTimeMax: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">End Time:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.endTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.endTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, endTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.endTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control mr-3"
                    value = {curFilter.endTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, endTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.endTimeMax || curFilter.endTimeMin?
                <span
                    onClick = {() => {setFilter({...curFilter, endTimeMin: "", endTimeMax: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Category:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.category} onChange = {e => {
                        setFilter({...curFilter, category: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.category).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.category !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, category: ""})}}
                >
                    ❌
                </span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Sub Category:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.subCategory} onChange = {e => {
                        setFilter({...curFilter, subCategory: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.subCategory).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.subCategory !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, subCategory: ""})}}
                >
                    ❌
                </span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Project:</span>
                <input
                    className = "form-control mr-3 inline"
                    value = {curFilter.projectName}
                    onChange = {e => {
                        setFilter({...curFilter, projectName: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.projectName !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, projectName: ""})}}
                >
                    ❌
                </span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Work Log Status:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.workLogStatus}
                    onChange = {e => {
                        setFilter({...curFilter, workLogStatus: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.workLogStatus).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.workLogStatus !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, workLogStatus: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Project Manager:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.projectManager}
                    onChange = {e => {
                        setFilter({...curFilter, projectManager: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.projectManager).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.projectManager !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, projectManager: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Project Description:</span>
                <input
                    className = "form-control mr-3 inline"
                    value = {curFilter.projectDescription}
                    onChange = {e => {
                    setFilter({...curFilter, projectDescription: e.currentTarget.value});
                    setCurrentPage(1);
                }}/>
                {
                curFilter.projectDescription !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, projectDescription: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Work Instruction Description:</span>
                <input
                    className = "form-control mr-3 inline"
                    value = {curFilter.workInstructionDescription}
                    onChange = {e => {
                        setFilter({...curFilter, workInstructionDescription: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.workInstructionDescription !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, workInstructionDescription: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Supervisor:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.supervisor}
                    onChange = {e => {
                        setFilter({...curFilter, supervisor: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.supervisor).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.supervisor !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, supervisor: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">JSA Initiator:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.teamLeadName}
                    onChange = {e => {
                        setFilter({...curFilter, teamLeadName: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.teamLeadName).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.teamLeadName !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, teamLeadName: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Role:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.laborCategory}
                    onChange = {e => {
                        setFilter({...curFilter, laborCategory: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.laborCategory).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.laborCategory !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, laborCategory: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Truck Number:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.truckNumber}
                    onChange = {e => {
                        setFilter({...curFilter, truckNumber: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {filteredWorkLogs0.map(f => f.truckNumber).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.truckNumber !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, truckNumber: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Per Diem:</span>
                <select
                    className = "form-control mr-3 inline"
                    value = {curFilter.perDiem}
                    onChange = {e => {
                        setFilter({...curFilter, perDiem: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "all">Select</option>
                    <option>No</option>
                    <option>Yes</option>
                </select>
                {
                curFilter.perDiem !== "all"?
                <span
                    onClick = {() => {setFilter({...curFilter, perDiem: "all"})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Location:</span>
                <input
                    className = "form-control mr-3 inline"
                    value = {curFilter.location}
                    onChange = {e => {
                    setFilter({...curFilter, location: e.currentTarget.value});
                    setCurrentPage(1);
                    }}
                />
                {
                curFilter.location !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, location: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Approver Comments:</span>
                <input
                    className = "form-control mr-3 inline"
                    value = {curFilter.decisionNotes}
                    onChange = {e => {
                    setFilter({...curFilter, decisionNotes: e.currentTarget.value});
                    setCurrentPage(1);
                }}/>
                {
                curFilter.decisionNotes !== ""?
                <span
                    onClick = {() => {setFilter({...curFilter, decisionNotes: ""})}}
                >
                    ❌
                </span>:null}
            </div>
            <div className = "mt-3 mb-3">
                <span
                    className = "btn btn-secondary"
                    onClick = {() => {
                        setFilter(defaultFilter);
                        setCurrentPage(1);
                    }}
                >
                    Clear Filter
                </span>
            </div>
        </Modal>
    )
}

function RenderedRow({
    id, 
    history, 
    setWorkLogs, 
    workLogs, 
    formName, 
    subFormName, 
    
    // workLog
    workLogHashKey, 
    projectHashKey, 
    usaTicketExpirationDate, 
    startTime, 
    endTime, 
    projectName, 
    category, 
    subCategory, 
    workLogStatus, 
    projectManager, 
    projectManagerEmail, 
    projectDescription, 
    workInstructionDescription, 
    supervisor, 
    supervisorEmail, 
    teamLeadName, 
    teamLead, 
    laborCategory, 
    truckNumber, 
    perDiem, 
    location, 
    contactName, 
    mobile, 
    siteContactName, 
    siteContactNumber, 
    cadRequired, 
    reportRequired, 
    decisionNotes, 
    workLog
}){
    return (<Fragment>
        <tr
            id = {workLogHashKey}
            className = "pointer"
            style = {{
                color: projectHashKey === restDayProjectHashKey?"green":"",
                background: usaExpireColorCode(usaTicketExpirationDate)
            }}
            onClick = {e => {
                if(!e.target.id){
                    if(projectHashKey === restDayProjectHashKey){
                        window.alert("Take a rest!");
                        return;
                    }
                    if(id !== e.currentTarget.id){      
                        history.push(`/${title}/${workLogHashKey}`);
                        scroll(e.currentTarget.id);
                    }else{
                        history.push(`/${title}`);
                        scroll(null);
                    }
                }
            }}
        >
            <td className = {id === workLogHashKey?"showMinus":"showPlus"}></td>
            <td>
                <strong>
                    <span style = {{fontSize: 20}}>{startTime.substring(0, 10)}</span>
                    {
                        startTime.substring(11, 16) === "00:00" && endTime.substring(11, 16) === "00:00"?
                        ``
                        :
                        ` ${startTime.substring(11, 16)}`
                    }
                    {
                        startTime.substring(0, 10) === endTime.substring(0, 10) && startTime.substring(11, 16) === "00:00" && endTime.substring(11, 16) === "00:00"?
                        ``
                        :
                        ` ~ `
                    }
                    {
                        startTime.substring(0, 10) === endTime.substring(0, 10)?
                            startTime.substring(11, 16) === "00:00" && endTime.substring(11, 16) === "00:00"?
                            ``
                            :
                            endTime.substring(11, 16)
                        :
                            startTime.substring(11, 16) === "00:00" && endTime.substring(11, 16) === "00:00"?
                            <span style = {{fontSize: 20}}>{endTime.substring(0, 10)}</span>
                            :
                            <>
                                <span style = {{fontSize: 20}}>{endTime.substring(0, 10)} </span>
                                {endTime.substring(11, 16)}
                            </>
                    }
                </strong>
            </td>
            <td>{projectName}</td>
            <td>{category}</td>
            <td>{subCategory}</td>
            <td>{workLogStatus}</td>
        </tr>
        <tr>
            <td className = "noborder" colSpan = {100}>
            <TransitionWidthHeight 
                classNames = "cssTDTransition"
                In = {id === workLogHashKey}
            >
                <div className = "border border-primary rounded container-fluid" style = {{transformOrigin:"top"}}>
                    <div className = "blk5" style = {{display: "flex", justifyContent: "space-between"}}>
                        <div className = "">
                            <table className = "table table-responsive-xl" style = {{fontSize: "calc(5px + 0.5vw)"}}>
                                <tbody>
                                <tr className = "noBorderTop">
                                    <th>Project Manager:</th>
                                    <td><UserInfo name = {projectManager} email = {projectManagerEmail}/></td>
                                </tr>
                                {usaTicketExpirationDate?
                                <tr>
                                    <th>USA Expire:</th>
                                    <td>{usaTicketExpirationDate}</td>
                                </tr>
                                :null}
                                <tr>
                                    <th>Project Description:</th>
                                    <td>
                                        <CKEditor
                                            editor = {ClassicEditor}
                                            onReady = {e => {
                                                if(e && e.sourceElement.nextElementSibling){
                                                    e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                                    e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                                                }
                                            }}
                                            config = {{
                                                toolbar: []
                                            }}
                                            disabled = {true} 
                                            data = {projectDescription}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Work Instruction Description:</th>
                                    <td>
                                        <CKEditor
                                            editor = {ClassicEditor}
                                            onReady = {e => {
                                                if(e && e.sourceElement.nextElementSibling){
                                                    e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                                    e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                                                }
                                            }}
                                            config = {{
                                                toolbar: []
                                            }}
                                            disabled = {true} 
                                            data = {workInstructionDescription}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Supervisor:</th>
                                    <td><UserInfo name = {supervisor} email = {supervisorEmail}/></td>
                                </tr>
                                <tr>
                                    <th>JSA Initiator:</th>
                                    <td><UserInfo name = {teamLeadName} email = {teamLead}/></td>
                                </tr>
                                <tr><th>Role:</th><td>{laborCategory}</td></tr>
                                {truckNumber?
                                <tr><th>Truck Number:</th><td>{truckNumber}</td></tr>
                                :null}
                                {perDiem === "Yes"?
                                <tr><th>Per Diem:</th><td>{perDiem}</td></tr>
                                :null}
                                <tr><th>Location:</th><td>{location}</td></tr>
                                <tr>
                                    <th>Requester Name:</th>
                                    <td>{contactName}</td>
                                </tr>
                                <tr>
                                    <th>Requester Phone Number:</th>
                                    <td>{mobile}</td>
                                </tr>
                                {siteContactName?<>
                                <tr>
                                    <th>Site Contact Name:</th>
                                    <td>{siteContactName}</td>
                                </tr>
                                <tr>
                                    <th>Site Contact Phone Number:</th>
                                    <td>{siteContactNumber}</td>
                                </tr>
                                </>:null}
                                <tr>
                                    <th>CAD Required:</th>
                                    <td>{cadRequired === null?"":(cadRequired === "1"?"Yes":"No")}</td>
                                </tr>
                                <tr>
                                    <th>Report Required:</th>
                                    <td>{reportRequired === null?"":(reportRequired === "1"?"Yes":"No")}</td>
                                </tr>
                                <tr><th>Approval Commetns:</th><td>
                                <CKEditor
                                    editor = {ClassicEditor}
                                    onReady = {e => {
                                        if(e && e.sourceElement.nextElementSibling){
                                            e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                            e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                                        }
                                    }}
                                    config = {{
                                    }}
                                    disabled = {true} 
                                    data = {decisionNotes}
                                /></td></tr>
                                </tbody>
                            </table>
                        </div>
                        <div className = "p-3">
                            
                        <FileSystem
                            fileSystem = {[{...fileSystemSchemaForProjects.find(schema => schema.name === "techniciansAttachments"), title: "Project Attachments"}]}
                            item = {workLog}
                            filesKey = "projectFiles"
                            readOnly = {true}
                            // projectFiles, projectFolderId
                        />
                        <FileSystem
                            fileSystem = {[{title: "Work Instruction Attachments"}]}
                            item = {workLog}
                            filesKey = "workInstructionFiles"
                            singleFolderId = "attachmentFolderId"
                            readOnly = {true}
                            // workInstructionFiles, attachmentFolderId, projectFolderId
                        />
                            <FileSystem
                                fileSystem = {[{title: "Your Attachments"}]}
                                setItems = {setWorkLogs}
                                sqlTable = "workLogs"
                                itemLabel = "work log"
                                hashKeyLabel = "workLogHashKey"
                                filesKey = "workLogFiles"
                                singleFolderId = "laborFolderId"
                                item = {workLog}
                                // workLogHashKey, workLogFiles, laborFolderId, projectFolderId, potholingForm, forms, jobTag
                            />
                        </div>
                        <div className = "col-1"></div>
                    </div>
                    {laborCategory !== "Images"?
                    <div className = "row">
                        <div className = "col-1"></div>
                        <div className = "col-10">
                            <WorkLogContent
                                setWorkLogs = {setWorkLogs} 
                                workLogs = {workLogs}
                                weeknum = {weeknum}
                                id = {id}
                                formName = {formName}
                                subFormName = {subFormName}
                                history = {history}

                                {...workLog}
                            />
                        </div>
                        <div className = "col-1"></div>
                    </div>
                    :null}
                </div>
                </TransitionWidthHeight>
            </td>
        </tr>
        </Fragment>);
}